import React from "react";

const EmailVerify = () => {
    const handleResend = (e) => {
        e.preventDefault();
        // Add resend logic here
        alert("Resend email clicked!");
    };

    return (
        <div className="dc-haslayout dc-jobalertsdashboard re-sendverification">
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 ">
                    <div className="dc-jobalerts">
                        <div className="alert alert-warning fade show">
                            <em>Verification&nbsp;:&nbsp;</em>
                            <span>Your account is not verified. Please check your email for the verification</span>
                            <button
                                className="dc-alertbtn warning"
                                onClick={handleResend}
                            >
                                Resend email
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailVerify;
